import React, { Component } from "react";
import logo from "logo.png";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "bootstrap/dist/js/bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { logout } from "store/actions/security";

class Header extends Component {
  logout = e => {
    e.preventDefault();
    this.props.logout(this.props.user);
    this.props.history.push("/");
  };
  render() {
    const { isAuth } = this.props;
    return (
      <div className="container">
        {!isAuth && (
          <nav className={"navbar navbar-expand-lg"}>
            <Link to="/publications">
              <img
                src={logo}
                className="header-App-logo navbar-brand"
                alt="logo"
              />
            </Link>

            <div className="ml-auto">
              <h5 className=" text-white">
                <strong className="text-ikea">IKEA Family</strong> vous offre un
                accès illimité au kiosque presse numérique pendant 3 mois.
              </h5>
              <Link to="/signup" className=" btn btn-outline-ikea flat">
                Je crée mon compte
              </Link>
            </div>
          </nav>
        )}
        {isAuth && (
          <nav className={"navbar navbar-expand-lg"}>
            <Link to="/publications">
              <img
                src={logo}
                className="header-App-logo navbar-brand"
                alt="logo"
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarApp"
              aria-controls="navbarApp"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="fas fa-bars text-white fa-2x"></i>
              </span>
            </button>
            <div className="collapse navbar-collapse" id="navbarApp">
              <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
                <li className="nav-item">
                  {isAuth && (
                    <Link to="/profile" className="text-white nav-link">
                      Mon compte
                    </Link>
                  )}
                </li>
                <li className="nav-item">
                  {isAuth && (
                    <Link
                      className="text-danger nav-link"
                      to="/"
                      onClick={this.logout}
                    >
                      Se deconneter
                    </Link>
                  )}
                </li>
              </ul>
            </div>
          </nav>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  apiKey: state.security.user
    ? state.security.user.api_key
    : process.env.REACT_APP_API_SECRETE,
  user: state.security.user,
  isAuth: Boolean(state.security.user)
});
const binActionsToProps = dispatch => ({
  logout: user => dispatch(logout(user))
});
export default connect(mapStateToProps, binActionsToProps)(Header);
